"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SitesList = void 0;
const filter_header_1 = require("client/components/filter-header");
// import { WarningIcon } from "client/components/icons";
// import { NotifyIcon } from "client/components/icons";
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const button_1 = require("client/components/material/button");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const floating_page_1 = require("client/components/page/floating-page");
const router_1 = require("client/components/router");
const store_1 = require("client/modules/app-settings/store");
const store_2 = require("client/modules/providers/store");
const store_3 = require("client/modules/users/store");
const Add_1 = require("material-ui-icons/Add");
const Notifications_1 = require("material-ui-icons/Notifications");
const Publish_1 = require("material-ui-icons/Publish");
const Warning_1 = require("material-ui-icons/Warning");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_1 = require("react");
const app_settings_1 = require("shared/app-settings");
const capitalize_string_1 = require("shared/util/capitalize-string");
const uppercase_string_1 = require("shared/util/uppercase-string");
const throttle_debounce_1 = require("throttle-debounce");
require("./sites-list.less");
const store_4 = require("./store");
const moment = require("moment");
const ReactTooltip = require("react-tooltip");
const switch_1 = require("client/components/material/switch");
const loading_indicator_1 = require("client/components/ui/loading-indicator");
const confirmation_modal_1 = require("client/components/confirmation-modal");
const columns = [
    {
        center: false,
        id: "displayName",
        numeric: false,
        label: "Pharmacy Name"
    },
    {
        center: false,
        id: "city",
        numeric: false,
        label: "Location"
    },
    {
        center: true,
        id: "totalClaims",
        // id: "NO_ACTION",
        numeric: false,
        label: "Total Claims",
        sortable: false
    },
    {
        center: true,
        id: "inventory",
        // id: "NO_ACTION",
        numeric: false,
        label: "Inventory",
        sortable: false
    },
    {
        center: false,
        id: "id",
        numeric: false,
        label: "",
        sortable: false
    },
    {
        center: false,
        id: "id",
        numeric: false,
        label: "",
        sortable: false
    }
];
const columnsWithoutInventory = [
    {
        center: false,
        id: "displayName",
        numeric: false,
        label: "Pharmacy Name"
    },
    {
        center: false,
        id: "city",
        numeric: false,
        label: "Location"
    },
    {
        center: true,
        id: "totalClaims",
        // id: "NO_ACTION",
        numeric: false,
        label: "Total Claims",
        sortable: false
    },
    {
        center: false,
        id: "id",
        numeric: false,
        label: "",
        sortable: false
    },
    {
        center: false,
        id: "id",
        numeric: false,
        label: "",
        sortable: false
    }
];
const columnsWitoutCount = [
    {
        center: false,
        id: "displayName",
        numeric: false,
        label: "Pharmacy Name"
    },
    {
        center: false,
        id: "city",
        numeric: false,
        label: "Location"
    },
    {
        center: false,
        id: "id",
        numeric: false,
        label: "",
        sortable: false
    },
    {
        center: false,
        id: "id",
        numeric: false,
        label: "",
        sortable: false
    }
];
const columnsWithoutClaims = [
    {
        center: false,
        id: "displayName",
        numeric: false,
        label: "Pharmacy Name"
    },
    {
        center: false,
        id: "city",
        numeric: false,
        label: "Location"
    },
    {
        center: true,
        id: "inventory",
        // id: "NO_ACTION",
        numeric: false,
        label: "Inventory",
        sortable: false
    },
    {
        center: false,
        id: "id",
        numeric: false,
        label: "",
        sortable: false
    },
    {
        center: false,
        id: "id",
        numeric: false,
        label: "",
        sortable: false
    }
];
let SitesList = class SitesList extends react_1.Component {
    constructor() {
        var _a, _b;
        super(...arguments);
        this.stroeOrder = localStorage.getItem("order");
        this.storeProperty = localStorage.getItem("property");
        this.order = (_a = this.stroeOrder) !== null && _a !== void 0 ? _a : "ASC";
        this.orderBy = (_b = this.storeProperty) !== null && _b !== void 0 ? _b : "displayName";
        this.showDisabled = false;
        this.filterText = "";
        this.daysPrior = 0;
        this.showInventoryCount = false;
        this.showClaimCount = false;
        this.isFilterPopup = false;
        this.loadSites = throttle_debounce_1.debounce(200, async () => {
            const query = {
                count: 100,
                order: this.order,
                search: this.filterText,
                sort: this.orderBy,
                start: 0,
                showDisabled: this.showDisabled,
                showInventoryCount: this.showInventoryCount,
                showClaimCount: this.showClaimCount //C-101
            };
            await store_4.sitesListStore.manualTest(query);
        });
        this.onHandleClickAddSite = () => {
            router_1.RouteManager.transitionTo("/pharmacies/0");
        };
        /**
         * #TODO B-028 #TODO E-033 Remember Last Selected Header Organization and
         * set the value on localstoreg to be remembered the filter
         * @param property;
         */
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
                localStorage.setItem("order", this.order);
                localStorage.setItem("property", property);
            }
            this.loadSites();
        };
        this.onCallback = (value) => {
            this.filterText = value;
            this.loadSites();
        };
        this.showCountPopup = () => {
            this.isFilterPopup = true;
        };
        this.onMouseEnter = () => {
            // console.log('onmouseleave');
        };
        this.onMouseLeave = () => {
            // console.log('onmouseleave');
        };
        this.handleDisabledToggle = async () => {
            this.showDisabled = !this.showDisabled;
            this.loadSites();
        };
        //C-101
        this.handleshowInventoryCountToggle = async () => {
            this.showInventoryCount = !this.showInventoryCount;
            this.loadSites();
        };
        //C-101
        this.handleshowClaimCountToggle = async () => {
            this.showClaimCount = !this.showClaimCount;
            this.loadSites();
        };
        this.renderTableRow = (row, index) => {
            if (!row.uploads)
                return;
            const today = moment().startOf("day");
            const uploadswithExpdate = row.uploads.filter(upload => upload.expDate !== null);
            let assetExpired = false;
            for (const item of uploadswithExpdate) {
                const expDate = moment(item.expDate);
                assetExpired = today.isSameOrAfter(expDate);
                if (assetExpired) {
                    break;
                }
            }
            let assetExpiring = false;
            for (const item of uploadswithExpdate) {
                const expDate = moment(item.expDate);
                const alertDateAsset = moment(item.expDate)
                    .subtract(this.daysPrior, "days")
                    .startOf("day")
                    .toString();
                assetExpiring = today.isBetween(alertDateAsset, expDate);
                if (assetExpiring) {
                    break;
                }
            }
            const disabledOrExpiredAccent = !row.live
                ? "disabled-site-accent"
                : assetExpired
                    ? "expired-license-accent"
                    : "";
            const missingRequiredAssetsforProvArray = this.missingRequiredAssets &&
                this.missingRequiredAssets.filter((asset) => asset.id === row.id);
            const rowUploadsArray = row.uploads.map((upload) => upload.connectAssetId);
            //  if rowUploadsArray contains the ids or the assetsArray then it should not have a warning, and missing will be empty
            const missing = missingRequiredAssetsforProvArray &&
                missingRequiredAssetsforProvArray.length &&
                missingRequiredAssetsforProvArray[0].assetsArray &&
                missingRequiredAssetsforProvArray[0].assetsArray.length &&
                missingRequiredAssetsforProvArray[0].assetsArray.filter((num) => num && !rowUploadsArray.includes(num.id));
            let missingRequired = false;
            if (missingRequiredAssetsforProvArray &&
                missingRequiredAssetsforProvArray.length &&
                missingRequiredAssetsforProvArray[0].assetsArray &&
                missingRequiredAssetsforProvArray[0].assetsArray.length > 0 &&
                missing &&
                missing.length > 0) {
                missingRequired = true;
            }
            const siteName = row.displayName || row.name || "";
            const cityState = `${capitalize_string_1.capitalizeString(row.city)}, ${uppercase_string_1.uppercaseString(row.state)}`;
            return (React.createElement(list_item_1.MaterialListItem, { key: index, to: `/pharmacies/${row.id}`, classes: { root: disabledOrExpiredAccent } },
                React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(siteName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: cityState }),
                this.showClaimCount && (React.createElement(list_item_text_1.MaterialListItemText, { primary: (row.orderCount && !store_4.sitesListStore.sites.loading) ||
                        row.orderCount === 0 ? (row.orderCount) : (React.createElement(loading_indicator_1.UiLoadingIndicator, null)) })),
                this.showInventoryCount && (React.createElement(list_item_text_1.MaterialListItemText, { primary: (row.inventorySiteCount && !store_4.sitesListStore.sites.loading) ||
                        row.inventorySiteCount === 0 ? (row.inventorySiteCount) : (React.createElement(loading_indicator_1.UiLoadingIndicator, null)) })),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: assetExpiring ? (React.createElement(Warning_1.default, { className: "warning-quantity--icon", "data-place": "right", "data-tip": "One or more assets are expiring soon.", "data-for": "warning-icon", fill: "#eeb20d" })) : assetExpired ? (React.createElement(Warning_1.default, { className: "warning-quantity--icon", "data-place": "right", "data-tip": "One or more assets expired.", "data-for": "warning-icon", fill: "#eeb20d" })) : null }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: missingRequired ? (React.createElement(Notifications_1.default, { className: "warning-quantity--icon", "data-tip": "Missing required certifications.", "data-place": "right", "data-for": "warning-icon", fill: "#eeb20d" })) : null })));
        };
        this.renderTable = () => {
            const { sites: { value: sites = [] } } = store_4.sitesListStore;
            const { ReadPharmacies } = store_3.usersStore.permissions; //B-063.11
            const updatedColumns = this.showInventoryCount && this.showClaimCount
                ? columns
                : this.showClaimCount
                    ? columnsWithoutInventory
                    : this.showInventoryCount
                        ? columnsWithoutClaims
                        : columnsWitoutCount;
            return (React.createElement("div", { className: "sites__list" },
                React.createElement(list_1.MaterialList, { columns: updatedColumns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: ReadPharmacies ? sites : this.assignedSiteLists(), renderRow: this.renderTableRow, resizableheader: true, customClass: "custom-material-list__sites-list" })));
        };
    }
    componentWillMount() {
        ReactTooltip.rebuild();
        if (store_3.usersStore &&
            store_3.usersStore.user &&
            store_3.usersStore.user.value &&
            store_3.usersStore.user.value &&
            store_3.usersStore.user.value.siteUser) {
            const siteId = store_3.usersStore.user.value.site.id;
            router_1.RouteManager.transitionTo(`/pharmacies/${siteId}`);
        }
    }
    async componentDidMount() {
        //B-063.11 2024-07-10 23:29:07
        const phamracyId = window.location.href.split("/")[4];
        if (phamracyId) {
            router_1.RouteManager.transitionTo(`/pharmacies`);
        }
        const daysSetting = await store_1.appSettingsStore.readSettings(app_settings_1.AppOption.DaysPriorProvExpLicense);
        this.daysPrior = Number(daysSetting.value);
        const query = {
            count: 100,
            order: this.order,
            search: this.filterText,
            sort: this.orderBy,
            start: 0,
            showDisabled: this.showDisabled,
            showInventoryCount: this.showInventoryCount,
            showClaimCount: this.showClaimCount //C-101
        };
        await store_4.sitesListStore.manualTest(query);
        await this.loadSites();
        const sites = store_4.sitesListStore.sites.value;
        const missingRequiredAssetsArray = await store_2.providersStore.getMissingRequiredAssets(sites, "site");
        this.missingRequiredAssets = missingRequiredAssetsArray
            ? Array.from(missingRequiredAssetsArray)
            : [];
        ReactTooltip.rebuild();
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    componentWillUnmount() {
        ReactTooltip.hide();
    }
    //B-063.11  2024-07-09 18:47:55
    assignedSiteLists() {
        const user = store_3.usersStore.user.value.sites || [];
        return store_4.sitesListStore.sites.value.filter((site) => user.includes(site.id));
    }
    render() {
        ReactTooltip.rebuild();
        return (React.createElement("div", { className: "sites" },
            React.createElement(ReactTooltip, { id: "warning-icon", className: "tooltip", effect: "solid", place: "left", "data-type": "warning", multiline: true }),
            this.isFilterPopup && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Reset", cancelText: "Cancel", message: "", addinModal: React.createElement("div", null,
                    React.createElement("div", { className: "filter-header__action" },
                        React.createElement(switch_1.MaterialSwitch, { label: "Show Claim Count", value: "true", checked: this.showClaimCount, onChange: this.handleshowClaimCountToggle })),
                    React.createElement("div", { className: "filter-header__action" },
                        React.createElement(switch_1.MaterialSwitch, { label: "Show Inventory Count", value: "true", checked: this.showInventoryCount, onChange: this.handleshowInventoryCountToggle }))), onCancel: () => {
                    this.isFilterPopup = false;
                }, onConfirm: () => {
                    this.showClaimCount = false;
                    this.showInventoryCount = false;
                    this.isFilterPopup = false;
                }, title: "View Count" })),
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement("div", { className: "sites__title-wrapper" },
                    React.createElement(kpi_title_1.KpiTitle, { label: "Pharmacies", subLabel: " " }),
                    store_3.usersStore.permissions.CreatePharmacy && ( // @TK allow all IMB users to add/edit all pharmacies.
                    React.createElement("div", { className: "floating-buttons", onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, tabIndex: 0 },
                        React.createElement(button_1.MaterialButton, { fab: true, secondary: true, className: "import-site-btn", to: "/pharmacies/import" },
                            React.createElement(Publish_1.default, null)),
                        React.createElement(button_1.MaterialButton, { fab: true, primary: true, className: "add-site-btn", to: "/pharmacies/0" },
                            React.createElement(Add_1.default, null)))))),
            React.createElement(floating_page_1.FloatingPage, null, this.renderMain())));
    }
    renderMain() {
        return React.createElement("div", { className: "sites__main" }, this.renderSites());
    }
    renderSites() {
        const permissionToViewDisabled = store_3.usersStore.permissions.ViewDisabledSites;
        return (React.createElement("div", { className: "sites__data" },
            React.createElement(filter_header_1.FilterHeader, { label: "Search", title: "Pharmacies", callBack: this.onCallback, withSwitch: permissionToViewDisabled, countFilter: true, switchChecked: this.showDisabled, switchLabel: "Show Disabled", handleToggle: this.handleDisabledToggle, handleToggle3: this.showCountPopup, filterText: this.filterText }),
            this.renderTable(),
            React.createElement(ReactTooltip, { effect: "solid", place: "left" })));
    }
};
__decorate([
    mobx_1.observable
], SitesList.prototype, "stroeOrder", void 0);
__decorate([
    mobx_1.observable
], SitesList.prototype, "storeProperty", void 0);
__decorate([
    mobx_1.observable
], SitesList.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], SitesList.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], SitesList.prototype, "showDisabled", void 0);
__decorate([
    mobx_1.observable
], SitesList.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], SitesList.prototype, "daysPrior", void 0);
__decorate([
    mobx_1.observable
], SitesList.prototype, "missingRequiredAssets", void 0);
__decorate([
    mobx_1.observable
], SitesList.prototype, "showInventoryCount", void 0);
__decorate([
    mobx_1.observable
], SitesList.prototype, "showClaimCount", void 0);
__decorate([
    mobx_1.observable
], SitesList.prototype, "isFilterPopup", void 0);
SitesList = __decorate([
    mobx_react_1.observer
], SitesList);
exports.SitesList = SitesList;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-list/sites-list.tsx
// module id = 4090
// module chunks = 0